<div class="form-input-error-component " *ngIf="hasError()">
  <!-- required -->
  <div *ngIf="controlName.errors?.required">
    <div *ngIf="this.errorMessage?.required; else defaultRequired">
      <span>{{ "error." + this.errorMessage.required | translate}}</span>
    </div>
    <ng-template #defaultRequired>
      <div [ngSwitch]="type">
        <div *ngSwitchCase="['radio', 'select'].includes(type) ? type : ''">
          <span>{{ erreurMessages.selectionnerValeur | translate}}</span>
        </div>
        <div *ngSwitchCase="'checkbox'">
          <span>{{ erreurMessages.cocherCase | translate}}</span>
        </div>
        <div *ngSwitchDefault>
          <span>{{ erreurMessages.champObligatoire | translate}}</span>
        </div>
      </div>
    </ng-template>
  </div>

  <div *ngIf="controlName.errors?.email">
    <div *ngIf="this.errorMessage?.email; else defaultEmail">
      <span>{{ "error." + this.errorMessage.email | translate}}</span>
    </div>
    <ng-template #defaultEmail>
      <span>{{ erreurMessages.formatMailInvalide | translate}}</span>
    </ng-template>
  </div>
  <div *ngIf="controlName.errors?.min">
    <div *ngIf="this.errorMessage?.min; else defaultMin">
      <span>{{ "error." + this.errorMessage.min | translate}}</span>
    </div>
    <ng-template #defaultMin>
      <span [translate]="erreurMessages.min"
            [translateParams]="{ value: unconvertDate(controlName.errors.min.min) }"></span>
    </ng-template>
  </div>
  <div *ngIf="controlName.errors?.minlength">
    <div *ngIf="this.errorMessage?.minLength; else defaultMinlength">
      <span>{{ "error." + this.errorMessage.minLength | translate}}</span>
    </div>
    <ng-template #defaultMinlength>
      <span [translate]="erreurMessages.minCaractere"
            [translateParams]="{ value: unconvertDate(controlName.errors.minlength.requiredLength) }"></span>
    </ng-template>
  </div>
  <div *ngIf="controlName.errors?.max">
    <div *ngIf="this.errorMessage?.max; else defaultMax">
      <span> {{ "error." + this.errorMessage.max | translate}}</span>
    </div>
    <ng-template #defaultMax>
      <span [translate]="erreurMessages.max"
            [translateParams]="{ value: unconvertDate(controlName.errors.max.max) }"></span>
    </ng-template>
  </div>
  <div *ngIf="controlName.errors?.maxlength">
    <div *ngIf="this.errorMessage?.maxLength; else defaultMaxlength">
      <span> {{ "error." + this.errorMessage.maxLength | translate}}</span>
    </div>
    <ng-template #defaultMaxlength>
      <span [translate]="erreurMessages.maxCaractere"
            [translateParams]="{ value: unconvertDate(controlName.errors.maxlength.requiredLength) }"></span>
    </ng-template>
  </div>
  <div *ngIf="controlName.errors?.minCaractere">
    <div *ngIf="this.errorMessage?.minCaractere; else defaultMinCaractere">
      <span>{{ "error." + this.errorMessage.minCaractere | translate}}</span>
    </div>
    <ng-template #defaultMinCaractere>
      <span [translate]="erreurMessages.minCaractere"
            [translateParams]="{ value: unconvertDate(controlName.errors.minCaractere.requiredLength) }"></span>
    </ng-template>
  </div>
  <div *ngIf="controlName.errors?.maxCaractere">
    <div *ngIf="this.errorMessage?.maxCaractere; else defaultMaxCaractere">
      <span>{{ "error." + this.errorMessage.maxCaractere | translate}}</span>
    </div>
    <ng-template #defaultMaxCaractere>
      <span [translate]="erreurMessages.maxCaractere"
            [translateParams]="{ value: unconvertDate(controlName.errors.maxCaractere.requiredLength) }"></span>
    </ng-template>
  </div>
  <!-- PRB0053517: affichage de la nouvelle erreur -->
  <div *ngIf="controlName.errors?.minTextLength">
    <div *ngIf="this.errorMessage?.minTextLength; else defaultMinMinTextLength">
      <span>{{ "error." + this.errorMessage.minTextLength | translate}}</span>
    </div>
    <ng-template #defaultMinTextLength>
      <span [translate]="erreurMessages.minTextLength"
            [translateParams]="{ value: unconvertDate(controlName.errors.minTextLength.requiredLength) }"></span>
    </ng-template>
  </div>
  <div *ngIf="controlName.errors?.pattern">
    <div *ngIf="this.errorMessage?.pattern; else defaultPattern">
      <span>{{ "error." + this.errorMessage.pattern | translate}}</span>
    </div>
    <ng-template #defaultPattern>
      <span *ngIf="eform" [translate]="erreurMessages.pattern_eform"
            [translateParams]="{ id: unconvertDate(field.id), type: field.type.toUpperCase() }"></span>
      <span *ngIf="!eform" [translate]="erreurMessages.pattern"
            [translateParams]="{ value: unconvertDate(controlName.errors.pattern.actualValue), pattern: controlName.errors.pattern.requiredPattern }"></span>
    </ng-template>
  </div>

  <div *ngIf="controlName.errors?.invalidReferenceValue">
    <span [translate]="erreurMessages.invalidReferenceValue"></span>
  </div>

  <!--  -->

  <div *ngIf="controlName.value?.ctrlValidation" >
    <span>{{ controlName.value.validation_message | translate }}</span>
  </div>


</div>
